module.exports = __webpack_public_path__ + "img/header_background.1b18ae12.png";